import {
  FETCH_OTHER_VENDORS_REQUEST,
  FETCH_OTHER_VENDORS_SUCCESS,
  FETCH_OTHER_VENDORS_FAILURE,
  FETCH_OTHER_VENDOR_BY_ID_REQUEST,
  FETCH_OTHER_VENDOR_BY_ID_SUCCESS,
  FETCH_OTHER_VENDOR_BY_ID_FAILURE,
  CREATE_OTHER_VENDOR_REQUEST,
  CREATE_OTHER_VENDOR_SUCCESS,
  CREATE_OTHER_VENDOR_FAILURE,
  UPDATE_OTHER_VENDOR_REQUEST,
  UPDATE_OTHER_VENDOR_SUCCESS,
  UPDATE_OTHER_VENDOR_FAILURE,
  DELETE_OTHER_VENDOR_REQUEST,
  DELETE_OTHER_VENDOR_SUCCESS,
  DELETE_OTHER_VENDOR_FAILURE,
  CLEAR_OTHER_VENDORS_ERROR,
  SET_SELECTED_OTHER_VENDOR,
  CLEAR_SELECTED_OTHER_VENDOR,
  UPDATE_VENDOR_VIEW,
} from '../../constants/redux';

import {
  getAllOtherVendors,
  getOtherVendorById,
  createOtherVendor,
  updateOtherVendor,
  deleteOtherVendor,
} from '../../api/vendors/otherVendors';

import { OtherVendor, CreateOtherVendorRequest, UpdateOtherVendorRequest } from '../../types/otherVendors';

// Action Creators
export const fetchOtherVendorsRequest = () => ({
  type: FETCH_OTHER_VENDORS_REQUEST,
});

export const fetchOtherVendorsSuccess = (vendors: OtherVendor[]) => ({
  type: FETCH_OTHER_VENDORS_SUCCESS,
  payload: vendors,
});

export const fetchOtherVendorsFailure = (error: string) => ({
  type: FETCH_OTHER_VENDORS_FAILURE,
  payload: error,
});

export const fetchOtherVendorByIdRequest = () => ({
  type: FETCH_OTHER_VENDOR_BY_ID_REQUEST,
});

export const fetchOtherVendorByIdSuccess = (vendor: OtherVendor) => ({
  type: FETCH_OTHER_VENDOR_BY_ID_SUCCESS,
  payload: vendor,
});

export const fetchOtherVendorByIdFailure = (error: string) => ({
  type: FETCH_OTHER_VENDOR_BY_ID_FAILURE,
  payload: error,
});

export const createOtherVendorRequest = () => ({
  type: CREATE_OTHER_VENDOR_REQUEST,
});

export const createOtherVendorSuccess = (vendor: OtherVendor) => ({
  type: CREATE_OTHER_VENDOR_SUCCESS,
  payload: vendor,
});

export const createOtherVendorFailure = (error: string) => ({
  type: CREATE_OTHER_VENDOR_FAILURE,
  payload: error,
});

export const updateOtherVendorRequest = () => ({
  type: UPDATE_OTHER_VENDOR_REQUEST,
});

export const updateOtherVendorSuccess = (vendor: OtherVendor) => ({
  type: UPDATE_OTHER_VENDOR_SUCCESS,
  payload: vendor,
});

export const updateOtherVendorFailure = (error: string) => ({
  type: UPDATE_OTHER_VENDOR_FAILURE,
  payload: error,
});

export const deleteOtherVendorRequest = () => ({
  type: DELETE_OTHER_VENDOR_REQUEST,
});

export const deleteOtherVendorSuccess = (vendorId: number) => ({
  type: DELETE_OTHER_VENDOR_SUCCESS,
  payload: vendorId,
});

export const deleteOtherVendorFailure = (error: string) => ({
  type: DELETE_OTHER_VENDOR_FAILURE,
  payload: error,
});

export const clearOtherVendorsError = () => ({
  type: CLEAR_OTHER_VENDORS_ERROR,
});

export const setSelectedOtherVendor = (vendor: OtherVendor | null) => ({
  type: SET_SELECTED_OTHER_VENDOR,
  payload: vendor,
});

export const clearSelectedOtherVendor = () => ({
  type: CLEAR_SELECTED_OTHER_VENDOR,
});

// Async Action Creators (Thunks)
export const fetchOtherVendorsList = (searchString?: string) => {
  return async (dispatch: any) => {
    dispatch(fetchOtherVendorsRequest());
    try {
      const vendors = await getAllOtherVendors(searchString);
      dispatch(fetchOtherVendorsSuccess(vendors));
    } catch (error: any) {
      dispatch(fetchOtherVendorsFailure(error.message));
    }
  };
};

export const fetchOtherVendor = (id: number) => {
  return async (dispatch: any) => {
    dispatch(fetchOtherVendorByIdRequest());
    try {
      const vendor = await getOtherVendorById(id);
      dispatch(fetchOtherVendorByIdSuccess(vendor));
      dispatch(setSelectedOtherVendor(vendor));
    } catch (error: any) {
      dispatch(fetchOtherVendorByIdFailure(error.message));
    }
  };
};

export const createOtherVendorAction = (vendorData: CreateOtherVendorRequest) => {
  return async (dispatch: any) => {
    dispatch(createOtherVendorRequest());
    try {
      const newVendor = await createOtherVendor(vendorData);
      dispatch(createOtherVendorSuccess(newVendor));
      return newVendor;
    } catch (error: any) {
      dispatch(createOtherVendorFailure(error.message));
      throw error;
    }
  };
};

export const updateOtherVendorAction = (id: number, vendorData: UpdateOtherVendorRequest) => {
  return async (dispatch: any) => {
    dispatch(updateOtherVendorRequest());
    try {
      const updatedVendor = await updateOtherVendor(id, vendorData);
      dispatch(updateOtherVendorSuccess(updatedVendor));
      dispatch(setSelectedOtherVendor(updatedVendor));
      return updatedVendor;
    } catch (error: any) {
      dispatch(updateOtherVendorFailure(error.message));
      throw error;
    }
  };
};

export const deleteOtherVendorAction = (id: number) => {
  return async (dispatch: any) => {
    dispatch(deleteOtherVendorRequest());
    try {
      await deleteOtherVendor(id);
      dispatch(deleteOtherVendorSuccess(id));
      dispatch(clearSelectedOtherVendor());
    } catch (error: any) {
      dispatch(deleteOtherVendorFailure(error.message));
      throw error;
    }
  };
};

// View Management Action
export const onChangeVendorView = (value: string) => async (dispatch: any) => {
  dispatch({
    type: UPDATE_VENDOR_VIEW,
    viewType: value,
  });
};
